import {Component, DestroyRef, effect, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MatDialog} from '@angular/material/dialog';
import {ErpOutboundPanelFilterService} from '../service/erp-outbound-panel-filter.service';
import {ErpOutboundFilterModalComponent} from '../components/erp-outbound-filter-modal/erp-outbound-filter-modal.component';

@Component({
  selector: 'app-erp-outbound-panel',
  templateUrl: './erp-outbound-panel.component.html',
  standalone: false,
})
export class ErpOutboundPanelComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly dialog = inject(MatDialog);
  private readonly filterService = inject(ErpOutboundPanelFilterService);

  constructor() {
    effect(() => {
      const open = this.filterService.toggleModal();
      if (!open) return;
      this.openFilters();
    });
  }

  private openFilters(): void {
    const dialog = this.dialog.open(ErpOutboundFilterModalComponent, {width: '700px', panelClass: 'erp-outbound-filter-dialog'});
    dialog.afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.filterService.toggleModal.set(false);
      });
  }
}
